export default __webpack_public_path__ + "static/feature_home_1_img_5-da188367318b89fe01bf829d30213b54.png";